import { el } from "./dom";
import { t } from "../i18n";
import type { AchievementDef } from "../game/achievements";

let container: HTMLElement | null = null;

function host(): HTMLElement {
  if (!container) {
    container = el("div", "toast-host");
    document.body.appendChild(container);
  }
  return container;
}

/** Show transient achievement-unlock toasts, staggered. */
export function showAchievementToasts(defs: AchievementDef[]): void {
  defs.forEach((def, i) => {
    setTimeout(() => {
      const toast = el("div", "toast");
      toast.innerHTML = `
        <span class="toast-icon">${def.icon}</span>
        <span class="toast-text">
          <span class="toast-title">${t("ach.unlocked")}</span>
          <span class="toast-name">${t(`ach.${def.id}`)}</span>
        </span>
        <span class="toast-reward">+${def.reward} ✦</span>`;
      host().appendChild(toast);
      requestAnimationFrame(() => toast.classList.add("show"));
      setTimeout(() => {
        toast.classList.remove("show");
        setTimeout(() => toast.remove(), 350);
      }, 2600);
    }, i * 400);
  });
}
